/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: "user",
  initialState: {
    modalStatus: false,
    selectedUser: null
  },
  reducers: {
    openAddUserModal: (state) => {
      state.modalStatus = "add";
    },
    openEditUserModal: (state, action) => {
      state.modalStatus = "edit";
      state.selectedUser = action.payload;
    },
    openDeleteUserModal: (state, action) => {
      state.modalStatus = "delete";
      state.selectedUser = action.payload;
    },
    closeUserModal: (state) => {
      state.modalStatus = false;
      state.selectedUser = null;
    }
  }
});

export const {
  openAddUserModal,
  openEditUserModal,
  openDeleteUserModal,
  closeUserModal
} = userSlice.actions;

export default userSlice.reducer;